export default "__VITE_ASSET__Pk$nkpsy__"